import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { memo, useState } from 'react';
import classNames from 'classnames/bind';
import { isFunction } from '@beef/utils';
import { useIsMobileDimension } from "../hooks/useGetDimensionGroup";
import { PlusIcon } from "../icons";
import { Text } from "../Text";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);

// Stateless component
export var ExpandingPanelStateless = /*#__PURE__*/memo(function (_ref) {
  var children = _ref.children,
    isOpen = _ref.isOpen,
    title = _ref.title,
    tagType = _ref.tagType,
    testName = _ref.testName,
    size = _ref.size,
    className = _ref.className,
    headerClassname = _ref.headerClassname,
    onClick = _ref.onClick,
    icon = _ref.icon;
  var isMobile = useIsMobileDimension();
  return /*#__PURE__*/React.createElement("div", {
    className: cn('expanding-panel', className),
    "data-component": testName
  }, /*#__PURE__*/React.createElement("button", {
    className: cn('expanding-panel__header', headerClassname, {
      'expanding-panel__header--opened': isOpen
    }),
    onClick: onClick,
    type: "button"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('expanding-panel__text')
  }, /*#__PURE__*/React.createElement(Text, {
    size: size,
    tagType: tagType
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: cn('expanding-panel__icon', {
      'expanding-panel__icon--opened': isOpen && !icon,
      'expanding-panel__icon--custom': isOpen && icon
    })
  }, icon || /*#__PURE__*/React.createElement(PlusIcon, {
    size: isMobile ? 20 : 24
  }))), /*#__PURE__*/React.createElement("div", {
    className: cn('expanding-panel__content', {
      'expanding-panel__content--opened': isOpen
    })
  }, children));
});

// Stateful component
export var ExpandingPanel = /*#__PURE__*/memo(function (props) {
  var _useState = useState(props.isOpen),
    _useState2 = _slicedToArray(_useState, 2),
    isPanelOpened = _useState2[0],
    setIsPanelOpened = _useState2[1];
  var handleClick = function handleClick() {
    if (isFunction(props === null || props === void 0 ? void 0 : props.onClick) && props !== null && props !== void 0 && props.onClick) {
      props.onClick();
    }
    setIsPanelOpened(function (isPanelOpenedVal) {
      return !isPanelOpenedVal;
    });
  };
  return /*#__PURE__*/React.createElement(ExpandingPanelStateless, _extends({}, props, {
    isOpen: isPanelOpened,
    onClick: handleClick
  }));
});
ExpandingPanel.displayName = ExpandingPanel.name;
ExpandingPanelStateless.displayName = ExpandingPanelStateless.name;